import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { MainLayout } from '../containers/MainLayout';

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      fontSize: 24
    }
  })
);

export const FailureScreen: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <MainLayout>
      <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <Box width={600}>
          <Typography variant="h1" classes={{ root: classes.title }}>
            {t('signup:error', 'Error')}
          </Typography>
          <Typography>{t('signup:unknownError', 'Unknown error, please try again later.')}</Typography>
        </Box>
      </Box>
    </MainLayout>
  );
};
